var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStarsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8537_58410)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.3335 8.66732L4.85647 9.71326C5.03346 10.0672 5.12196 10.2442 5.24018 10.3976C5.34509 10.5337 5.4671 10.6557 5.6032 10.7606C5.75657 10.8789 5.93357 10.9674 6.28755 11.1443L7.3335 11.6673L6.28755 12.1903C5.93357 12.3673 5.75657 12.4558 5.6032 12.574C5.4671 12.6789 5.34509 12.8009 5.24018 12.937C5.12196 13.0904 5.03346 13.2674 4.85647 13.6214L4.3335 14.6673L3.81052 13.6214C3.63353 13.2674 3.54503 13.0904 3.42681 12.937C3.3219 12.8009 3.19989 12.6789 3.06379 12.574C2.91042 12.4558 2.73343 12.3673 2.37944 12.1903L1.3335 11.6673L2.37944 11.1443C2.73343 10.9674 2.91042 10.8789 3.06379 10.7606C3.19989 10.6557 3.3219 10.5337 3.42681 10.3976C3.54503 10.2442 3.63353 10.0672 3.81052 9.71326L4.3335 8.66732Z",
    stroke: "#424242",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0002 1.33398L10.7859 3.37693C10.9739 3.86575 11.0679 4.11016 11.2141 4.31575C11.3437 4.49795 11.5029 4.65715 11.6851 4.78671C11.8907 4.93289 12.1351 5.0269 12.6239 5.2149L14.6668 6.00065L12.6239 6.7864C12.1351 6.97441 11.8907 7.06841 11.6851 7.21459C11.5029 7.34415 11.3437 7.50335 11.2141 7.68556C11.0679 7.89114 10.9739 8.13555 10.7859 8.62437L10.0002 10.6673L9.21441 8.62437C9.02641 8.13555 8.9324 7.89114 8.78622 7.68556C8.65666 7.50335 8.49747 7.34415 8.31526 7.21459C8.10967 7.06841 7.86526 6.97441 7.37644 6.7864L5.3335 6.00065L7.37644 5.2149C7.86526 5.0269 8.10967 4.93289 8.31526 4.78671C8.49746 4.65715 8.65666 4.49795 8.78622 4.31575C8.9324 4.11016 9.02641 3.86575 9.21441 3.37693L10.0002 1.33398Z",
    stroke: "#424242",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8537_58410"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarsIcon);
export default __webpack_public_path__ + "static/media/stars-icon.d1df80e2e60b0fabae29572faf0034d2.svg";
export { ForwardRef as ReactComponent };